import { Model } from './model';

export class CustomerSegment extends Model {
  id: string;

  name: string;

  description: string | null;

  priority: number;

  conditions: Record<string, any> | null;
}
